import { useState, useRef, useEffect } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FiX } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { BsCartDashFill } from "react-icons/bs";
import { removeFromCart } from "../../../redux/actions/cart/cart.actions";

const Cart = ({ setToggle }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const cart = useSelector((state) => state.cart);
  const itemref = useRef(null);
  const [cartItems, setCartItems] = useState([])

  useEffect(() => {
    setCartItems(cart?.items)
  }, [cart])

  const handleRemoveItem = (id) => {
    dispatch(removeFromCart(id))
  }

  return (
    <div className="cart-box-Main p-0">
      <div className="nb-pointer"></div>
      <div className="text-start rounded-3 overflow-hidden cartbox bg-white" >
        <div className="cartbox-Header text-white">
          <div className="py-3 d-flex align-items-center" role="button" onClick={() => navigate('/my-cart')}>
            <span className="fw-bolder fs-6 ps-4">My Cart</span>
            {/* <FaArrowRight
              className="text-white ms-2"
              role="button"
            /> */}
          </div>
          <FiX
            className="fs-4 text-white me-3"
            role="button"
            onClick={() => setToggle(false)}
          />
        </div>

        {/* Cart Div */}
        <div className="notifications">
          {!cart ? <div style={{ display: "flex", justifyContent: "center", margin: "5%" }}>
            <div className="loading2">
            </div>
          </div>
          :
          cartItems.length <= 0 ?
            <div className="w-100 text-center mt-5"  >
              <p className="text-dark m-auto fs-5 fw-bold">No items here</p>
            </div> :
            cartItems.map((item, index) => {
              return (
                <div
                  key={index}
                  data-itemfication-id={item.id}
                  ref={(ref) => (itemref.current = ref)}
                  id={item?._id}
                  className="d-flex align-items-center rounded-3 px-3"
                  style={{ height: 60, cursor: "pointer", backgroundColor: "#ffffff" }}
                  onClick={() => navigate('/my-cart')}
                >
                  <div className="pe-3">
                    <img
                      src={ !item.image ? "/img/upload-photo.png" : item.image }
                      height={40}
                      style={{ width: "40px", height: "40px", borderRadius: 50, objectFit: "cover" }}
                      alt="ibouge"
                    />
                  </div>
                  <div className="py-2 h-100 text-dark d-flex flex-column flex-grow-1">
                    <span style={{ fontWeight: "600", fontSize: 12, color: "black" }}>{item.productName}</span>
                    <span style={{ paddingTop: 3, fontSize: 10, fontWeight: "300", color: "black" }}>
                      ${item.price}
                    </span>
                  </div>
                  <div className="">
                    <BsCartDashFill
                      onClick={(e)=> {
                        e.stopPropagation();
                        handleRemoveItem(item?.productId)
                      }}
                      style={{marginTop: -5}}
                      size={22}
                      color="#6148A1"
                    />
                  </div>
                </div>
              );
            })}
        </div>
        {/* ^ Cart Div */}

      </div>
      {/* ^ Main Div */}
    </div>
  );
};

export default Cart;